export const GET_SALES_SUCCESS = "getSalesSucces"
export const GET_SALE_SUCCESS = "getSaleSucces"
export const CHANGE_SALE_STATUS_SUCCESS = "changeSaleStatusSuccess"